/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue';
import Axios from 'axios';
import { message } from './resetMessage.js';
import router from '../router';
import store from '../store';

Axios.defaults.baseURL = '/supply/admin/';
Axios.defaults.headers.common.Accept = 'application/json';
const id_token = store.state.id_token;

function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  }
  return null;
}

Axios.interceptors.request.use((config) => {
  let userinfo = getCookie('userinfo');
  if (userinfo) {
    userinfo = JSON.parse(userinfo);
    if (userinfo.token) {
      sessionStorage.setItem(id_token, userinfo.token);
    }
    // store.commit('common/LOGIN_USER', userinfo);
  }
  // 判断是否存在id_token，有则放入http头一起请求
  if (sessionStorage.getItem(id_token)) {
    if (!('Authorization' in config.headers)) {
      config.headers.Authorization = `Bearer ${sessionStorage.getItem(id_token)}`;
    }
    if (!config.headers.Authorization) {
      delete config.headers.Authorization;
    }
  }
  if (getCookie('csrfToken')) {
    config.headers['x-csrf-token'] = getCookie('csrfToken');
  }
  // console.log(i18n.locale)
  const lang = window.localStorage.getItem('lang');
  if (lang) {
    // i18n.locale = lang;
  }
  // if (i18n.locale !== 'cn') {
  //   config.headers.lang = i18n.locale;
  // }
  return config;
}, err => Promise.reject(err));

Axios.interceptors.response.use(
  response => response
  ,
  (error) => {
    let errorMessage = error.message;
    if (error.response.status === 401) {
      // store.dispatch('user/logout');
    }
    if (error.response.status === 403) {
      // store.commit('user/LOGOUT_USER');
      // router.push({ name: 'home.index' });
      // store.commit('common/NOLOGIN', true);
      message({
        message: 'token错误, 请重新登录',
        type: 'error',
        onClose: () => {
          router.push({ path: '/login' });
        }
      })
      return Promise.reject(error);
    }
    if (error.response.status === 400 || error.response.status === 401) {
      const data = error.response.data;
      if (!data.to_method) {
        message({
          message: data.msg,
          type: 'error'
        })
        // let tips = '';
        // if (data.message) {
        //   // tips = i18n.t(`server.${data.message}`);
        //   if (data.add_msg) {
        //     for (const key in data.add_msg) {
        //       tips = tips.replace(new RegExp(`{${key}}`, 'g'), data.add_msg[key]);
        //     }
        //   }
        // } else {
        //   tips = data;
        // }
        // store.commit('common/NEWDIALOG', [true, tips]);

      } else {
        return Promise.reject(error);
      }
    }
    const userinfo = getCookie('userinfo');
    if (!userinfo && !sessionStorage.getItem(id_token)) {
      // router.push('home.index');
    }
    return Promise.reject(error);
  });

// Bind Axios to Vue.
Vue.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});



// WEBPACK FOOTER //
// ./src/until/axios.js